import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './Router/Router';
import * as serviceWorker from './serviceWorker';
import {BrowserRouter as Router} from 'react-router-dom';
import history from './Router/history';
import configureStore from './reducers/index';
import { firebase } from './firebase/firebase';
import {Provider} from "react-redux";
import {logout, adminLogin, adminLogout, companyLogout,
companyLogin,
login} from './actions/auth_actions';
import {startSetCompany, startShowVacancies} from './actions/initializer_actions';
import {loadStudentProfile} from './actions/_student_actions';
import {showVacanciesAdmin} from './actions/_admin_actions';
import BarLoader from 'react-spinners/BarLoader';

const store = configureStore();

const Page = (
    <Provider store={store}>
        <Router history={history}>
            <App />
        </Router>
    </Provider>
);
let hasRendered = false;
let listener = false;
const loading = (
    <div className="rel full">
        <div className="above-center">
            <h4 className="text-center">Cargando .....</h4>
        </div>
        <div className="real-center">
            <BarLoader
                width={350}
                size={100}
                height={5}
                sizeUnit={'px'}
                color={'#f47b20'}
            />
        </div>
    </div>
)
const renderApp = () => {
    if (!hasRendered){
        ReactDOM.render(Page, document.getElementById("root"))
    }
}
ReactDOM.render(loading, document.getElementById('root'));
serviceWorker.unregister();
store.dispatch(startShowVacancies());

let verifyUser = () => {
    firebase.auth().onAuthStateChanged((user) => {
        if(!listener){
            if (user) {
                ReactDOM.render(loading, document.getElementById('root'));
                if(user.emailVerified){
                    user.getIdTokenResult().then((idTokenResult) => {
                        if(idTokenResult.claims.typeuser === "adminUser"){
                            store.dispatch(adminLogin(user.uid, idTokenResult.claims.typeuser))
                            store.dispatch(showVacanciesAdmin()).then(()=>{
                                setTimeout(() => {
                                    renderApp()
                                }, 2000)
                            })
                            history.push("/management/vacancies");
                        }else if(idTokenResult.claims.typeuser === "student"){
                            store.dispatch(login(user.uid, idTokenResult.claims.typeuser))
                            store.dispatch(loadStudentProfile(user.uid)).then(() => {
                                setTimeout(() => {
                                    renderApp()
                                }, 2000)
                            })
                            history.push("/joblisting");
                        }else if(idTokenResult.claims.typeuser === "company"){
                            store.dispatch(companyLogin(user.uid, idTokenResult.claims.typeuser));
                            store.dispatch(startSetCompany()).then(()=>{
                                setTimeout(() => {
                                    renderApp()
                                }, 2000)
                            })
                            history.push("/company/vacancies");
                        }
                    }).catch((error) => {
                        console.log(error);
                    });
                }else {
                    store.dispatch(logout());
                    store.dispatch(adminLogout());
                    store.dispatch(companyLogout());
                    setTimeout(()=>{
                        renderApp()
                    },2000)
                }
            } else {
                if(history.location.pathname === "/management"){
                    store.dispatch(adminLogout());
                    history.push("/management");
                    setTimeout(() => {
                        renderApp()
                    }, 2000)
                }else if(history.location.pathname === "/company"){
                    store.dispatch(companyLogout());
                    history.push("/company");
                    setTimeout(() => {
                        renderApp()
                    }, 2000)
                }
                else{
                    store.dispatch(logout());
                    history.push("/");
                    setTimeout(() => {
                        renderApp()
                    }, 2000)
                }
            }
            listener = true
        }
    });
}

verifyUser();